import { QuoteStatus } from '@lockton-apps/shared/interfaces';

export abstract class QuoteStatusMetaPipe<T> {
  abstract map: Map<QuoteStatus, T>;

  transform(value: QuoteStatus): T {
    return this.map.get(value) || this.defaultValue;
  }

  abstract defaultValue: T;
}
